import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'oap-cookies-headband',
    templateUrl: 'cookiesHeadband.component.html'
})

export class CookiesHeadbandComponent {

    public isVisible: boolean;

    constructor(private cookieService: CookieService) {
        this.isVisible = false
        const cookiesValue = this.cookieService.get('oap-cookies-consent');
        if(cookiesValue === null || cookiesValue === '') {
            this.isVisible = true
        }
    }

    consent() {
        this.setCookieConsent('true')
    }

    reject() {
        this.setCookieConsent('false')
    }

    setCookieConsent(choice) {
        let expiredDate = new Date();
        expiredDate.setDate( expiredDate.getDate() + 183 );
        this.cookieService.set('oap-cookies-consent', choice, expiredDate, null, null, null, null)
        this.isVisible = false
    }
}